(ns app.front.view.application
  (:require ["react-transition-group/esm/CSSTransition" :default CSSTransition]
            [app.domain.complaint.model :as complaint-model]
            [app.domain.form.model :as form-model]
            [app.domain.form.schema :as form-schema]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.form.add :as add-form]
            [app.front.form.subs :as form-subs]
            [app.front.municipality :as municipality]
            [app.front.process :as process]
            [app.front.requirement.events :as req-events]
            [app.front.requirement.subs :as requirement-subs]
            [app.front.review-v2.applicant :as review-applicant]
            [app.front.review-v2.subs :as review-subs]
            [app.front.root :as root]
            [app.front.ui :as ui]
            [app.front.ui.error-boundary :as eb]
            [app.front.ui.section :as section]
            [app.front.util :refer [for-all] :as futil]
            [app.front.view.agreement.list :as agreement-list]
            [app.front.view.appeals.appeals-section :as appeals-section]
            [app.front.view.application-wizard.summary :as wizard-summary]
            [app.front.view.application.application-reports :as application-reports]
            [app.front.view.application.committee-meetings :as committee-section]
            [app.front.view.application.page-content :as app-page]
            [app.front.view.application.permissions :as app-permissions]
            [app.front.view.application.phase-subs :as app-phase-subs]
            [app.front.view.application.progress :as app-progress]
            [app.front.view.application.reviews :as application-reviews]
            [app.front.view.application.target-times :as application-target-times]
            [app.front.view.application.transfer-of-permit :as transfer-of-permit]
            [app.front.view.application.utils :as app-utils]
            [app.front.view.application.withdrawal :as application-withdrawal]
            [app.front.view.application.work-type-target :as work-select]
            [app.front.view.approval.core :as approval]
            [app.front.view.archiving.view :as archiving-view]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.attachment.list :as attachment-list]
            [app.front.view.attachment.modal :as attachment-modal]
            [app.front.view.attachment.subs :as attachment-subs]
            [app.front.view.bim.core :as bim]
            [app.front.view.bond.workspace-section :as bond]
            [app.front.view.case-description.case-description :as case-description]
            [app.front.view.case-note.section :as case-note]
            [app.front.view.case-note.subs :as cn-subs]
            [app.front.view.complaint.complaints-section :as complaints-section]
            [app.front.view.conditions.list :as conditions-list]
            [app.front.view.council-decision.list :as council-decision-list]
            [app.front.view.fee.bond :as fee-bond]
            [app.front.view.fee.list :as fee-list]
            [app.front.view.form.list :as form-list]
            [app.front.view.inspections.events :as inspection-events]
            [app.front.view.inspections.orders-section :as orders-section]
            [app.front.view.inspections.section :as inspections-section]
            [app.front.view.inspections.ws-violations :as ws-violations]
            [app.front.view.letter.section :as letter-section]
            [app.front.view.media-attachment.list :as media-attachment-list]
            [app.front.view.not-found :as not-found]
            [app.front.view.occupancy.download :as occupancy-download]
            [app.front.view.occupancy.edit :as occupancy-edit]
            [app.front.view.occupancy.list :as occupancy-list]
            [app.front.view.package.package-section :as package-section]
            [app.front.view.party.party-section-v2 :as party-section-v2]
            [app.front.view.periodic-inspection :as periodic-inspection]
            [app.front.view.permit.core :as permit]
            [app.front.view.permit.list :as permit-list]
            [app.front.view.phase-event.section :as phase-event]
            [app.front.view.phase-event.subs :as phase-event-subs]
            [app.front.view.phase-result :as phase-result]
            [app.front.view.pre-consultation.view :as pc-view]
            [app.front.view.property.issues :as property-issues]
            [app.front.view.property.owner :as property-owner]
            [app.front.view.public-notice.core :as public-notice-view]
            [app.front.view.workspace.additional-properties :as additional-properties]
            [app.front.view.workspace.closure-category :as closure-category]
            [app.front.view.workspace.get :as ws-get]
            [app.front.view.workspace.header :as ws-header]
            [app.front.view.workspace.hidden-description :as ws-hidden-desc]
            [app.front.view.workspace.phase-errors :as phase-errors]
            [app.front.view.workspace.phase-indicator :as pi]
            [app.front.view.workspace.related-workspace :as related-workspace]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [app.front.view.workspace.util :as workspace-util]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-db ::exit-view
  (fn [db]
    (dissoc db :view/workspace)))


(rf/reg-sub ::acknowledgements
  :<- [::ws-subs/workspace]
  :<- [::entities/context]
  (fn [[workspace ctx] [_ only-pending?]]
    (entities/find-entities ctx (merge {:order.acknowledgement/workspace (:db/id workspace)}
                                       (when only-pending?
                                         {:domain/state :order.acknowledgement.state/pending})))))


(rf/reg-event-fx ::redirect-to-acknowledgement
  (fn [_ [_ workspace-id]]
    {:route/replace {:route :view/acknowledge :params {:workspace-id workspace-id}}}))


(defn- active-acknowledgements [db ctx workspace-id]
  (let [workspace               (entities/find-entity ctx {:workspace/id workspace-id})
        active-acknowledgements (entities/find-entities
                                  ctx
                                  {:order.acknowledgement/workspace (:db/id workspace)
                                   :domain/state                    :order.acknowledgement.state/pending})
        fetch-status            (get-in db [:view/workspace :fetch-status])
        allowed?                (app-permissions/can-bypass-acknowledgement? db)]
    (when (and (not allowed?)
               ;; this makes sure that the workspace/get has already fetched the data
               (not= :fetching fetch-status))
      active-acknowledgements)))

(rf/reg-event-fx ::navigate-acknowledgements
  (fn [{{::entities/keys [entity-db components schema] :as db} :db} [_ match]]
    (let [workspace-id    (:workspace-id (get-in match [:parameters :path]))
          workspace-state (-> entity-db
                              vals
                              (p/find-first {:workspace/id workspace-id})
                              :domain/state)
          name            (get-in match [:data :name])]
      (if (active-acknowledgements db (util/mmap entity-db components schema) workspace-id)
        {:route/replace {:route :view/acknowledge :params {:workspace-id workspace-id}}}
        (when (= name :view/workspace)
          {:dispatch [::app-phase-subs/redirect-to-current-phase workspace-id workspace-state]})))))


(rf/reg-event-fx ::navigate-workspace
  (fn [{:keys [db]} [_ {:keys [workspace-id]}]]
    {:db (-> (assoc db :view/workspace {:fetch-status :fetching})
             (dissoc ::ws-header/address-in-editor ::root/ws-conversation-notification-count))
     :fx [[:dispatch [::ws-get/get-for-application-view workspace-id]]
          [:dispatch [::ws-header/close-map]]
          [:dispatch [::add-form/close-add-form-modal]]]}))

(defn set-config-data-for-ws-view [db response-data]
  (-> db
      ;; first remove the current config data
      (update :view/workspace #(apply dissoc % workspace-model/config-data-for-ws-view-keys))
      (update :view/workspace merge (select-keys response-data workspace-model/config-data-for-ws-view-keys))))

(defn bill-schedule-ids-requiring-data [bills]
  (->> bills
       (filter (du/in-state-fn :bill.state/draft :bill.state/paid))
       (map :bill/schedule)))

(rf/reg-event-fx ::workspace-fetch-success
  (fn [{:keys [db]} [_ workspace-id status data]]
    (let [ents                    (-> data :entities)
          new-entity-ctx          {:entity-db  ents
                                   ;; schema may not be populated, so dont rely on it
                                   :components nil
                                   :schema     nil}
          find-entity             (partial entities/find-entity new-entity-ctx)
          workspace               (find-entity {:workspace/id workspace-id})
          workspace-state         (-> workspace :domain/state)
          application             (find-entity
                                    {:entity/parent (:db/id workspace)
                                     :entity/type   :entity.type/application})
          bills                   (entities/find-entities new-entity-ctx {:entity/type :entity.type/bill})
          execution               (find-entity
                                    {:entity/parent (:db/id workspace)
                                     :entity/type   :entity.type/execution})
          authority-group         (find-entity (-> workspace :domain/authority-group))
          domain-group            (find-entity (-> authority-group :entity/parent))
          new-db                  (-> db
                                      (assoc :view/workspace
                                             (assoc (merge (workspace-util/workspace-view-data workspace application execution authority-group)
                                                           (select-keys data [:last-state-change-date
                                                                              :limited-visibility-for-other-departments
                                                                              :payment-use-municipal-case-id
                                                                              :unfinished-import-session-id]))
                                                    ::root/ws-conversation-notification-count (:conversation-notification-count data)))
                                      (set-config-data-for-ws-view data))
          ;; we need to give a pseudo-populated app-db and entity-db for active-acknowledgements
          ;; so that the permission check it does succeeds
          active-acknowledgements (active-acknowledgements (-> new-db
                                                               (assoc-in [:view/workspace :fetch-status] :success)
                                                               (update ::entities/entity-db merge ents))
                                                           new-entity-ctx
                                                           workspace-id)
          authority?              (-> workspace :granted-permissions :permission.application/review)
          country                 (-> workspace :workspace/municipality find-entity :municipality/country)
          ;; bare entity maps are enough for checking for form inline status, as we cannot
          ;; rely on schema being loaded at this point
          app-form-schema-ids     (->> ents
                                       vals
                                       (filter (eu/is-type-fn :entity.type/form-schema))
                                       (remove #(-> % :form.schema/type (= :form.schema.type/sign-off)))
                                       (filter :form.schema/data-schema)
                                       du/entity-id-set)
          forms                   (->> ents
                                       vals
                                       (filter (eu/is-type-fn :entity.type/form))
                                       (filter #(-> % :form/schema app-form-schema-ids)))
          email-log-ids           (when authority?
                                    (->> ents
                                         vals
                                         (filter (eu/is-type-fn :entity.type/approval))
                                         (keep :entity/related-emails)
                                         (apply concat)
                                         seq))]
      (if-not (= (:group/uri-path-id domain-group) (:branding db))
        {:dispatch [:branding/force-branding (:group/uri-path-id domain-group)]}
        {:db                new-db
         :dispatch-n        (concat
                              [[::ws-get/get-workspace-config (-> workspace
                                                                  :domain/authority-group
                                                                  find-entity
                                                                  :group/id)]
                               [::process/fetch-process-states
                                country
                                (:workspace/permit-type workspace)
                                (:process-flow data)]
                               [::entities/override-entity-db-for-all {:entity/type :entity.type/sign-off} status ents]
                               (when-let [execution-id (:db/id execution)]
                                 [::entities/override-entity-db-for-all
                                  {:entity/type   :entity.type/phase-result
                                   :entity/parent execution-id}
                                  status
                                  ents])
                               [::entities/merge-entity-db status ents]
                               (if active-acknowledgements
                                 ;; if workspace has orders that need to be acknowledged redirect to acknowledgement page
                                 [::redirect-to-acknowledgement workspace-id]
                                 [::app-phase-subs/redirect-to-current-phase workspace-id workspace-state])
                               [::review-subs/fetch-group-reviewers (:db/id authority-group)]
                               [::inspection-events/fetch-inspections workspace-id]
                               (when authority?
                                 [::ws-header/fetch-authority-users workspace-id])
                               (when authority?
                                 [::fee-list/fetch-fee-schedules workspace-id (bill-schedule-ids-requiring-data bills)])
                               [::municipality/load-map-config (-> domain-group :group/id)]
                               [::fee-bond/init]
                               (when (fee-bond/bondable-fees? ents (:db/id application))
                                 [::fee-bond/fetch-bond-status (:db/id application)])
                               (when (fee-bond/bondable-fees? ents (:db/id execution))
                                 [::fee-bond/fetch-bond-status (:db/id execution)])
                               (when email-log-ids
                                 [::ws-get/get-email-logs workspace-id email-log-ids])
                               [::req-events/verify-review-integration-from-storage]]
                              (when (and (= :view/application-wizard-workspace (-> db :route/match :data :name))
                                         (= "summary" (-> db :route/match :parameters :path :step)))
                                [[::wizard-summary/maybe-fetch-permit-estimate]])
                              (when (form-model/forms-inline? forms)
                                ;; if forms inline, fetch form additional data
                                (->> forms
                                     (map (fn [{form-id :db/id}]
                                            [::form-subs/navigate-form {:form-id form-id}])))))
         :dispatch-debounce {:id      ::fetch-status-debounce
                             :timeout 0
                             :action  :dispatch
                             :event   [::ws-subs/set-fetch-status :success]}}))))

(rf/reg-sub ::application-state
  :<- [::ws-subs/application]
  (fn [app]
    (-> app :domain/state)))

(rf/reg-sub ::attachment-types
  :<- [::ws-subs/enabled-attachment-type-ids]
  :<- [::ws-subs/loading-config?]
  (fn [[type-ids loading?] _]
    (if loading?
      []
      (<sub [::entities/entities type-ids]))))


(rf/reg-sub ::attachment-types-with-i18n
  :<- [::attachment-types]
  :<- [:language]
  (fn [[attachment-types language] _]
    (->> attachment-types
         (map (juxt #(attachment-common/attachment-type-label % language) :db/id))
         (sort-by first))))


(defn- open-attachments-section-fx [section]
  [[:dispatch [::section/toggle-collapsed (section/get-section-id section) false]]
   [::futil/scroll-to-section section]])

(defn- open-attachments-section-with-popup-fx [section]
  (conj (open-attachments-section-fx section)
        [:dispatch [:app.front.requirement.components/open-add-requirement-popup]]))

(rf/reg-sub ::execution-attachments-section-open?
  (fn [db _]
    (get db ::execution-attachments-section-open? false)))

(rf/reg-event-fx ::trigger-scroll-to-execution-attachments
  (fn [{:keys [db]} _]
    {:db (assoc db ::execution-attachments-section-open? true)
     :fx (open-attachments-section-fx :execution-attachments)}))

(rf/reg-event-fx ::trigger-add-execution-attachment-requirement
  (fn [{:keys [db]} _]
    {:db (assoc db ::execution-attachments-section-open? true)
     :fx (open-attachments-section-with-popup-fx :execution-attachments)}))

(rf/reg-sub ::occupancy-section-open?
  (fn [db _]
    (get db ::occupancy-section-open? false)))

(rf/reg-event-fx ::trigger-open-occupancy-section
  (fn [{:keys [db]} _]
    {:db (assoc db ::occupancy-section-open? true)
     :fx [[::futil/scroll-to-section :execution-occupancy]]}))

(rf/reg-sub ::application-attachments-section-open?
  (fn [db _]
    (get db ::application-attachments-section-open? false)))

(rf/reg-event-fx ::trigger-scroll-to-application-attachments
  (fn [{:keys [db]} _]
    {:db (assoc db ::application-attachments-section-open? true)
     :fx (open-attachments-section-fx :application-attachments)}))

(rf/reg-event-fx ::trigger-add-application-attachment-requirement
  (fn [{:keys [db]} _]
    {:db (assoc db ::application-attachments-section-open? true)
     :fx (open-attachments-section-with-popup-fx :application-attachments)}))

(rf/reg-sub ::case-data-section-visible?
  (fn [[_ execution]]
    [(rf/subscribe [::form-subs/has-forms? execution])
     (rf/subscribe [::process/signal-permitted? (:db/id execution) [:process.signal/add-form]])
     (rf/subscribe [::ws-subs/has-feature? :execution-forms?])])
  (fn [[execution-has-forms? add-form-permitted? group-has-execution-form-schemas?] [_ execution]]
    (let [permit-type (-> execution :entity/parent :workspace/permit-type)]
      (and (contains? form-schema/permit-types-with-execution-form permit-type)
           (or execution-has-forms?
               (and add-form-permitted?
                    group-has-execution-form-schemas?))))))

(rf/reg-sub ::attachment-status
  (fn [[_ application-id]]
    [(rf/subscribe [::requirement-subs/open-attachment-requirements application-id])
     (rf/subscribe [::work-select/work-type-target-set?])])
  (fn [[attachment-requirements work-type-and-target-set?] _]
    (if (not work-type-and-target-set?)
      :unavailable
      (if (not-empty attachment-requirements) :error :done))))


;;
;; Reports
;;

(rf/reg-sub ::show-reports?
  (fn [[_ application] _]
    [(rf/subscribe [::entities/entities {:entity/type   :entity.type/planning-draft-report
                                         :entity/parent (:db/id application)}])
     (rf/subscribe [::entities/entities {:entity/type   :entity.type/planning-final-report
                                         :entity/parent (:db/id application)}])
     (rf/subscribe [::entities/entities {:entity/type   :entity.type/planning-uploaded-report
                                         :entity/parent (:db/id application)}])
     (rf/subscribe [:app.front.process/app-signal-permitted? [:process.signal/edit-draft-report]])
     (rf/subscribe [:app.front.process/app-signal-permitted? [:process.signal/edit-final-report]])
     (rf/subscribe [:app.front.process/app-signal-permitted? [:process.signal/add-uploaded-report]])])
  (fn [[draft-reports final-reports uploaded-reports can-edit-draft? can-edit-final? can-upload?]]
    (or (seq draft-reports)
        (seq final-reports)
        (seq uploaded-reports)
        can-edit-draft?
        can-edit-final?
        can-upload?)))

(rf/reg-sub ::pre-selected-entity-id
  :<- [:route/match]
  (fn [match _]
    (-> match :parameters :query :id)))

;; FIXME use smaller subscriptions, not one massive
(rf/reg-sub ::state
  :<- [::ws-subs/pre-consultation]
  :<- [::ws-subs/application]
  :<- [::ws-subs/execution]
  :<- [::ws-subs/periodic-parent]
  :<- [::ws-subs/archiving]
  :<- [::ws-subs/workspace-state]
  :<- [::ws-subs/tr]
  :<- [::ws-subs/loading?]
  :<- [::ws-subs/workspace]
  :<- [:session/authority-user?]
  :<- [::pre-selected-entity-id]
  (fn [[pre-consultation
        application
        execution
        periodic-parent
        archiving
        workspace-state
        tr
        loading?
        workspace
        authority?
        pre-selected-entity-id] _]
    {:pre-consultation       pre-consultation
     :application            application
     :execution              execution
     :workspace              workspace
     :periodic-parent        periodic-parent
     :archiving              archiving
     :workspace-state        workspace-state
     :tr                     tr
     :loading?               loading?
     :authority?             authority?
     :pre-selected-entity-id pre-selected-entity-id}))


(defn application-parties [{:keys [tr application]}]
  [party-section-v2/parties (util/mmap {:parent application
                                        :error? (<sub [::app-progress/party-errors?])}
                                       tr)])


(defn case-data [{:keys [loading? workspace tr execution]}]
  (let [auth-group-id (-> execution
                          :entity/parent
                          :domain/authority-group
                          :db/id)
        permit-type   (:workspace/permit-type workspace)]
    [:<>
     [ws-section/section
      execution
      :code-enforcement-forms                               ;; legacy id
      (util/mmap {:heading-button    [add-form/add-button {:process-target-id  (:db/id execution)
                                                           :authority-group-id auth-group-id
                                                           :opts               {:kind :ghost
                                                                                :icon i/plus}
                                                           :button-text        (tr [:process.signal/add-form])
                                                           :add-text           (tr [:add])
                                                           :cancel-text        (tr [:cancel])}]
                  :heading-tag       (<sub [::form-subs/phase-forms-count execution])
                  :heading-tag-color (if (<sub [::form-subs/missing-any-data? execution]) :yellow :green)}
                 tr loading?)
      (if (= permit-type :permit-type/PI) :periodic-parent/forms :execution-data)
      false
      [form-list/forms
       (util/mmap {:parent execution
                   :lang   (<sub [:language])}
                  tr
                  workspace
                  loading?)]]
     [add-form/add-form-modal {:tr tr :process-target execution}]]))


(defn application-forms [{:keys [tr workspace loading? application]}]
  [form-list/forms
   (util/mmap {:loading? (or loading? (<sub [::work-select/forms-reloading]))
               :parent   application
               :lang     (<sub [:language])}
              tr
              workspace)])

(defn application-data [{:keys [tr application workspace] :as state}]
  (let [missing-data?    (<sub [::form-subs/missing-any-data? application])
        forms-reloading? (<sub [::work-select/forms-reloading])
        has-forms?       (<sub [::form-subs/has-forms? application])
        can-add?         (<sub [::process/signal-permitted? application [:process.signal/add-form]])
        ui-improvements? (<sub [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
        show-section?    (if ui-improvements?
                           (or forms-reloading? has-forms?)
                           (or forms-reloading? has-forms? can-add?))]
    [:<>
     (when show-section?
       [ws-section/section
        application
        :application-data
        (assoc state
               :heading-button [add-form/add-button {:process-target-id  (:db/id application)
                                                     :authority-group-id (-> application
                                                                             :entity/parent
                                                                             :domain/authority-group
                                                                             :db/id)
                                                     :opts               {:kind :ghost
                                                                          :icon i/plus}
                                                     :button-text        (tr [:process.signal/add-form])
                                                     :add-text           (tr [:add])
                                                     :cancel-text        (tr [:cancel])}]
               :heading-tag (<sub [::form-subs/phase-forms-count application])
               :heading-tag-color (if missing-data? :yellow :green))
        (if (:workspace/legacy-permit? workspace) :permit-information :forms-title)
        true
        [application-forms state]])
     [add-form/add-form-modal {:tr tr :process-target application}]]))

(defn- wizard-precheck-status-label [status]
  (case status
    "possible_issue" :application/wizard-precheck-possible-issue
    "missing_evidence" :application/wizard-precheck-missing-evidence
    "uncertain" :application/wizard-precheck-uncertain
    nil))

(defn- wizard-precheck-source-groups [findings]
  (->> findings
       (group-by :wizard-ai-rule-check-finding/source-file)
       (map (fn [[source source-findings]]
              {:id       (:db/id source)
               :name     (:file/filename source)
               :findings (sort-by :db/id source-findings)}))
       (sort-by (fn [{:keys [id name]}]
                  [(nil? id) (str/lower-case (or name "")) (or id 0)]))))

(defn- wizard-precheck-finding [tr {:keys [wizard-ai-rule-check-finding/status
                                           wizard-ai-rule-check-finding/applicant-message
                                           wizard-ai-rule-check-finding/evidence]}]
  [:li.py-2.border-b.border-solid.border-ui-light-gray.last:border-b-0
   (when-let [label (wizard-precheck-status-label status)]
     [:div.mb-1.text-xs.font-semibold
      [ui/small-pill {:kind :secondary :uppercase? false} (tr [label])]])
   (when-not (str/blank? applicant-message)
     [:p.pb-0.text-sm.leading-snug applicant-message])
   (when-not (str/blank? evidence)
     [:p.mt-1.pb-0.pl-2.border-l-2.border-solid.border-ui-light-gray.text-sm.leading-snug.text-gray-600
      [:span.font-semibold.mr-1 (tr [:application/wizard-precheck-evidence])]
      evidence])])

(defn- application-wizard-precheck [{:keys [application tr] :as state}]
  (let [findings (:application/wizard-ai-rule-check-findings application)]
    (when (and (seq findings)
               (<sub [::ff/enabled? :feature-flag.id/workspace-precheck-results])
               (-> application :granted-permissions :permission.phase/read))
      (let [application-id   (:db/id application)
            visible-findings (remove #(contains? #{"not_applicable" "apparent_match"}
                                                 (:wizard-ai-rule-check-finding/status %))
                                     findings)
            groups           (wizard-precheck-source-groups visible-findings)
            name-count       (frequencies (keep :name groups))]
        [ws-section/section
         application
         :wizard-precheck
         (assoc state :heading-tag (count visible-findings) :initially-collapsed? true)
         :application/wizard-precheck
         false
         [:div {:data-guide-id    "wizard-precheck"
                :data-guide-label (tr [:application/wizard-precheck])}
          [:p.pb-0.mb-3.text-sm.text-gray-600
           (tr [:application/wizard-precheck-description])]
          (when (empty? visible-findings)
            [:p.py-2.text-sm.text-gray-600 (tr [:application/wizard-precheck-filter-empty])])
          ^{:key application-id}
          [cc/accordion {:class-name "[&>li>div]:pr-4"}
           (futil/for-frag [{:keys [id name findings]} groups]
             [cc/accordion-item
              {:data-cy          "wizard-precheck-source-group"
               :class-name       "break-words"
               :icon-description (str (tr [:open]) "/" (tr [:close]))
               :title            (str (or name (tr [:application/wizard-precheck-source-unavailable]))
                                      " (" (count findings) ")"
                                      (when (> (get name-count name 0) 1)
                                        (str " — " (tr [:application/wizard-precheck-source-id] [id]))))}
              [:ul.list-none
               (futil/for-frag [finding findings]
                 [wizard-precheck-finding tr finding])]])]]]))))

(defn application-attachments [{:keys [application] :as state} match]
  (let [errors?              (= :error (<sub [::attachment-status (:db/id application)]))
        attachments?         (<sub [::attachment-subs/has-attachments? (:db/id application)])
        can-create?          (<sub [::process/signal-permitted?
                                    application
                                    [:process.signal/attachment-create-with-version]])
        pre-selected-id      (-> match :parameters :query :id)
        ui-improvements?     (<sub [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
        section-open?        (<sub [::application-attachments-section-open?])
        show-section?        (if ui-improvements?
                               (or attachments? errors? section-open?)
                               (or attachments? errors? can-create?))
        initially-collapsed? (not (or section-open? pre-selected-id))]
    (when show-section?
      [ws-section/section
       application
       :application-attachments
       (assoc state :error? errors?)
       :view/application-attachments
       initially-collapsed?
       ^{:key "application-attachments"}
       [attachment-list/list-view
        {:target                application
         :pre-selected-id       pre-selected-id
         :render-preview-modal? false}]])))


(defn- execution-occupancy [{:keys [execution tr] :as state}]
  (let [lang                (<sub [:language])
        ws-id               (<sub [::ws-subs/workspace-id])
        po-apps             (<sub [::occupancy-list/partial-occupancy-apps])
        enable-permitted?   (<sub [:app.front.process/execution-signal-permitted?
                                   [:process.signal/set-partial-occupancy]])
        apply-permitted?    (<sub [:app.front.process/execution-signal-permitted?
                                   [:process.signal/apply-partial-occupancy]])
        visits-with-permits (<sub [::occupancy-download/visits-with-permits (:db/id execution)])
        ui-improvements?    (<sub [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
        section-open?       (<sub [::occupancy-section-open?])
        has-content?        (or (seq po-apps) (seq visits-with-permits))
        show-section?       (if ui-improvements?
                              (or has-content? section-open?)
                              (or has-content? enable-permitted? apply-permitted?))]
    (when show-section?
      [ws-section/section
       execution
       :execution-occupancy
       state
       :view/occupancy
       true
       [occupancy-download/view state visits-with-permits]
       [occupancy-edit/partial-occupancy-enable-section (util/mmap execution tr ws-id) enable-permitted? apply-permitted?]
       [occupancy-list/view (util/mmap execution lang tr ws-id) po-apps apply-permitted?]])))


(defn application-permits [{:keys [application workspace tr] :as state}]
  (let [can-permit? (<sub [:app.front.process/app-signal-permitted? [:process.signal/create-verdict]])
        verdicts    (<sub [::entities/entities {:entity/type   :entity.type/verdict
                                                :entity/parent (:db/id application)}])]
    ;; if permit is issued but there are unpaid fees - permits are not shown
    (when (or (seq verdicts)
              can-permit?)
      [ws-section/section
       application
       :application-permits
       (assoc state :heading-button [permit/draft-button state])
       :permit/permits
       (not= "section--application-permits" (futil/get-anchor)) ; initially collapsed for applicant, unless navigated by an anchor link
       (when (seq verdicts)
         [:div {:key "permits"}
          [permit-list/permit-list application workspace tr verdicts]])])))


(defn show-reviews? [{:keys [application]}]
  (or (and (<sub [:app.front.process/app-signal-permitted? [:process.signal/create-review]])
           (<sub [::review-subs/ws-review-configs]))
      (seq (<sub [::entities/entities {:entity/type   :entity.type/review
                                       :entity/parent (:db/id application)}]))))


(defn- public-notice-section [{:keys [workspace fsm-target] :as state}]
  (when (<sub [::public-notice-view/section-visible? (:db/id fsm-target)])
    [public-notice-view/section state (:workspace/id workspace)]))


(defn phase-application [{:keys [loading? application workspace tr fsm-target] :as state} match]
  (let [;; Check if the new billing feature is configured for the group
        fees-and-payments?              (:fees-and-payments? (<sub [::ws-subs/group-features]))
        phase-id                        (:db/id fsm-target)
        content                         [:<>
                                         [application-target-times/target-times-section]
                                         [application-withdrawal/withdrawal-info state]
                                         [application-withdrawal/cancel-withdrawal-info state]
                                         [application-withdrawal/rejection-info state]
                                         [appeals-section/appeals-section]
                                         [application-withdrawal/refusal-info state]
                                         [application-withdrawal/denial-info state]
                                         [conditions-list/conditions-and-comments-section state application]
                                         [bond/workspace-bonds-section state]
                                         [application-parties state]
                                         [committee-section/meetings-section {:phase-entity application}]
                                         [transfer-of-permit/transfer-of-permit-section state]
                                         [application-data state]
                                         [application-wizard-precheck state]
                                         (when fees-and-payments?
                                           [fee-list/fees-and-payments-section (util/mmap tr loading?) application])
                                         [application-attachments state match]
                                         (when (<sub [::ws-subs/has-feature? :group.feature/bim-ifc-checking])
                                           [bim/section (util/mmap {:phase application}
                                                                   tr state)])
                                         (when (<sub [::cn-subs/show-case-notes-section? (:db/id application)])
                                           [case-note/section (util/mmap {:phase application} state)])]
        show-reports?                   (<sub [::show-reports? application])
        show-applicant-review-progress? (and (<sub [::review-subs/has-change-requests? phase-id])
                                             (<sub [::ws-subs/user-is-party-with-write-auths?]))]
    [app-page/page-content
     (util/mmap {:process-target application
                 :process        (<sub [::process/application-process])}
                workspace
                tr
                loading?)
     [attachment-modal/attachment-preview-modal (util/mmap tr)]
     (if (or (<sub [::ws-subs/loading-config?])
             (<sub [:comm/command-processing? :group/process-states]))
       (cc/skeleton-text {:data-cy "main-progress-loading"})
       [app-progress/render-application-progress
        ;; hide progress widget if review errors widget is visible, unless there are application-level
        ;; errors too
        (assoc state :hide-if-no-errors? show-applicant-review-progress?)])
     (when show-applicant-review-progress?
       [review-applicant/applicant-review-progress (util/mmap phase-id tr)])
     [phase-result/result-section state]
     content
     (when (show-reviews? state)
       (if (<sub [::ws-subs/loading-config?])
         [section/section-skeleton]
         [application-reviews/view state]))
     [approval/approvals state]
     (when show-reports? [application-reports/reports state])
     [agreement-list/list-view state]
     [council-decision-list/list-view state]
     [inspections-section/inspections-section (assoc state :target-entity application)]
     (when (and (<sub [::ws-subs/has-feature? :orders-for-inspections-enabled?])
                (<sub [::ff/enabled? :feature-flag.id/pre-issuance-inspections]))
       [orders-section/section (assoc state :target-entity application)])
     [application-permits state]
     [public-notice-section state]
     (when (<sub [::process/app-signal-permitted? [:process.signal/create-admin-package]])
       [package-section/packages (assoc state :target-entity application)])
     [letter-section/letters-section (util/mmap {:target-id phase-id} tr)]]))


(defn phase-execution [{:keys [tr execution workspace loading? pre-selected-entity-id] :as state}]
  (let [inspection-ids       (->> (<sub [::inspections-section/inspections-raw (:db/id execution)])
                                  (map :db/id))
        attachments?         (<sub [::attachment-subs/has-attachments? (:db/id execution)])
        requirements?        (seq (<sub [::requirement-subs/open-attachment-requirements (:db/id execution)]))
        complaints           (seq (complaint-model/workspace-complaints workspace))
        ui-improvements?     (<sub [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
        attachments-open?    (<sub [::execution-attachments-section-open?])
        show-attachments?    (if ui-improvements?
                               (or attachments? requirements? attachments-open?)
                               (or attachments?
                                   requirements?
                                   (<sub [::process/signal-permitted? execution [:process.signal/attachment-create-with-version]])))
        initially-collapsed? (not (or attachments-open? pre-selected-entity-id))]
    [app-page/page-content
     (util/mmap {:process-target execution
                 :process        (<sub [::process/execution-process])}
                workspace
                tr
                loading?)
     [application-withdrawal/blocking-info state]
     [application-withdrawal/lapse-info state]
     [closure-category/workspace-summary tr workspace execution]
     [phase-errors/errors tr [::process/execution-process]]
     [appeals-section/appeals-section]
     (when (<sub [::phase-event-subs/show-phase-event-section? (:db/id execution)])
       [phase-event/section (util/mmap {:phase execution} state)])
     (when (or (<sub [::process/signal-permitted? execution [:process.signal/remove-complaint-from-case]])
               complaints)
       [complaints-section/section])
     (when (-> workspace :workspace/permit-type (= :permit-type/PI))
       [periodic-inspection/periodic-inspection-section-in-child state])
     [bond/workspace-bonds-section state]
     [party-section-v2/parties (util/mmap {:parent execution} tr)]
     (when (or (<sub [::process/signal-permitted? execution [:process.signal/set-case-description]])
               (some? (:workspace/case-description workspace)))
       [case-description/section])
     (when (<sub [::case-data-section-visible? execution])
       [case-data state])
     (when (<sub [::media-attachment-list/show-media-attachments-section? (:db/id execution) inspection-ids])
       [media-attachment-list/media-attachment-section
        (util/mmap {:target         execution
                    :title          (tr [:code-enforcement/case-attachments])
                    :inspection-ids inspection-ids} tr)])
     (when show-attachments?
       [ws-section/section
        execution
        :execution-attachments
        (util/mmap {:error? requirements?} tr loading?)
        :view/application-attachments
        initially-collapsed?
        ^{:key "execution-attachments"}
        [attachment-list/list-view
         {:target          execution
          :pre-selected-id pre-selected-entity-id}]])
     [execution-occupancy state]
     (when (<sub [::cn-subs/show-case-notes-section? (:db/id execution)])
       [case-note/section (util/mmap {:phase execution} state)])
     [ws-violations/violations-for-workspace state]
     [letter-section/letters-section (util/mmap {:target-id (:db/id execution)} tr)]
     [inspections-section/inspections-section (assoc state :target-entity execution)]
     (when (<sub [::ws-subs/has-feature? :orders-for-inspections-enabled?])
       [orders-section/section (assoc state :target-entity execution)])
     (when (<sub [::ws-subs/has-feature? :fees-and-payments?])
       [fee-list/fees-and-payments-section (util/mmap tr loading?) execution])
     [conditions-list/conditions-and-comments-section state execution]
     [committee-section/meetings-section {:phase-entity execution}]
     [approval/approvals state]
     (when (or (= (<sub [::ws-subs/permit-type]) :permit-type/PWO)
               (<sub [::ff/enabled? :feature-flag.id/public-notice-in-execution]))
       [public-notice-section state])
     (when (<sub [::process/execution-signal-permitted? [:process.signal/view-audit-log]])
       [:div.text-right
        [:a {:href (href/href :view/audit-log {:workspace-id (<sub [::ws-subs/workspace-id])})}
         (tr [:notifications/audit-log])]])
     (when (<sub [::process/execution-signal-permitted? [:process.signal/create-admin-package]])
       [package-section/packages (assoc state :target-entity execution)])
     [phase-result/result-section state]]))


(defmulti phase-view (fn [phase] phase))

(defmethod phase-view :workspace.state/pre-consultation [_]
  (let [loading?  (<sub [::ws-subs/loading?])
        workspace (<sub [::ws-subs/workspace])
        tr        (<sub [::ws-subs/tr])
        match     (<sub [:route/match])]
    [pc-view/phase-pre-consultation (util/mmap loading? workspace tr)
     match]))

(defmethod phase-view :workspace.state/application [_]
  (let [state       (<sub [::state])
        application (<sub [::ws-subs/application])
        match       (<sub [:route/match])]
    [phase-application (assoc state :fsm-target application) match]))

(defmethod phase-view :workspace.state/execution [_]
  (let [state     (<sub [::state])
        execution (<sub [::ws-subs/execution])]
    (when (:execution state)
      [phase-execution (assoc state :fsm-target execution)])))

(defmethod phase-view :workspace.state/periodic-parent [_]
  (let [state           (<sub [::state])
        periodic-parent (<sub [::ws-subs/periodic-parent])]
    (when (:periodic-parent state)
      [periodic-inspection/phase-periodic-parent (assoc state :fsm-target periodic-parent)])))

(defmethod phase-view :workspace.state/archiving [_]
  (let [state (<sub [::state])]
    [archiving-view/archiving-view state]))

(defn phase-indicator [tr]
  (let [phases              (<sub [::app-phase-subs/phases])
        current-phase-index (<sub [::app-phase-subs/current-phase-index])
        current-child       (<sub [::app-phase-subs/current-child])
        curr-process        (<sub [::process/entity-process current-child])
        process-state       (:domain/state current-child)
        loading?            (<sub [::ws-subs/loading?])]
    (when (or loading? (seq phases))
      [pi/render-phase-indicator
       #(>evt [::app-phase-subs/set-phase-in-view (-> phases (nth %) :view-name)])
       (util/mmap loading? tr phases current-child current-phase-index)
       (app-utils/phase-step-state process-state curr-process)
       (app-utils/direct-transitions process-state curr-process)])))

(defn phase-skeleton []
  [:div
   [:div.my-8 (cc/skeleton-text {:heading true})]
   [section/section-skeleton]])

(defn phase-content []
  (let [phases              (<sub [::app-phase-subs/phases])
        animation-direction (<sub [::app-phase-subs/animation-direction])
        current-phase-index (<sub [::app-phase-subs/current-phase-index])
        loading?            (<sub [::ws-subs/loading?])]
    [:div.relative
     (if loading?
       [phase-skeleton]
       (for-all [{:keys [name index]} phases]
         ^{:key (str "phase-" index)}
         [:> CSSTransition
          {:classNames      (if (= animation-direction :previous) "fade-right" "fade-left")
           :timeout         400
           :in              (= current-phase-index index)
           :unmount-on-exit true}
          [eb/error-boundary
           [phase-view name]]]))]))

(defn application-found-view [_]
  (let [current-child (<sub [::app-phase-subs/current-child])
        workspace     (<sub [::ws-subs/workspace])
        lang          (<sub [:language])
        tr            (<sub [::ws-subs/tr])
        target-id     (:db/id current-child)]
    [:div
     {:class-name     "cloudpermit-page workspace-page"
      :data-entity-id (<sub [::ws-subs/application-id])}
     [ws-header/header (util/mmap lang tr current-child)]
     [related-workspace/related-workspaces-section (util/mmap target-id workspace)]
     [additional-properties/additionals-section (util/mmap target-id workspace tr)]
     [ws-hidden-desc/hidden-description (util/mmap tr)]
     [phase-indicator tr]
     [property-owner/external-ownership-info-modal (util/mmap lang tr) workspace]
     [property-issues/external-issues-modal tr]
     [phase-content]]))

(defn application [match]
  (if (<sub [::ws-subs/not-found])
    [not-found/not-found-view]
    [application-found-view match]))
